import firebase from '../../../config/firebase';

const database = firebase.database();

/**
 * get all newsletters of moose
 */
export function getNewsletters(callback) {
  database.ref('news').on('value', function(snapshot) {
    const news = snapshot.val();
    callback(true, news, null);
  });
}

export function setNewsletters(data, callback) {
  database.ref('news').set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  }).catch((error) => alert(error));
}
